import { Component } from '@angular/core';
import * as AOS from 'aos';

import { Title, Meta } from '@angular/platform-browser';

import { Constants } from '../../common/constants';
import { SeoService } from 'src/app/common/seo.service';
@Component({
  selector: 'app-itstaffings-blog',
  templateUrl: './itstaffings-blog.component.html',
  styleUrls: ['./itstaffings-blog.component.css']
})
export class ItstaffingsBlogComponent {
  baseUrl=Constants.baseUrl;
  constructor(
    private titleService: Title,
    private metaService: Meta,
    private seoService:SeoService
  ) {}

  ngOnInit(): void {
    this.setTitleAndMetaTags();
    this.seoService.createLinkForCanonicalURL();
  }
  private setTitleAndMetaTags(): void {
    this.titleService.setTitle('The Key to Employee Happiness in Achieving Work-Life Balance');

    this.metaService.addTags([
      { name: 'description', content: 'In our fast-paced contemporary world, the pursuit of happiness has become intricately entwined with the relentless pursuit of professional success.' },
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: 'The Key to Employee Happiness in Achieving Work-Life Balance' },
      { property: 'og:url', content: 'https://mitresource.com/it-staffing/' },
      { property: 'og:image', content: 'https://mitresource.com/assets/images/blogs/WorkLifeBalance.png' },
      { property: 'og:description', content: 'In our fast-paced contemporary world, the pursuit of happiness has become intricately entwined with the relentless pursuit of professional success.' },
    ]);
  }
}
